<div class="fixed transform z-5" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<p-toast [style]="{width: '25vw',opacity:'1'}" position="top-right" key="save" (onClose)="onReject()"
  [baseZIndex]="5000"></p-toast>
<p-toast [style]="{width: '25vw',opacity:'1'}" position="top-right" key="cancleCase" (onClose)="onReject()"
  [baseZIndex]="5000"></p-toast>
<ng-container *ngIf="!EditScreenBool">
  <div class="bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
      <div class="conten">
        <div class="btn"><a>Cases</a></div>
      </div>
    </div>
    <div class="bg-default px-3 pb-3">
      <div class="grid cases-screen mt-3">
        <!-- Filters -->
        <div class="col-12 md:col-6 lg:col-2">
          <label for="caseNumber"><b>Facility:</b></label>
          <p-multiSelect 
          class="w-full custom-dropdown" 
          [options]="facilityList"  [style]="{'width':'100%', 'white-space': 'normal', 'line-height': '1.5'}" 
          [panelStyle]="{'overflow-x': 'hidden', 'word-wrap': 'break-word'}"
          placeholder="--Select Facility--"  defaultLabel="--Select--" display="chip" 
          [(ngModel)]="selectedFacility" optionLabel="Text" optionValue="Value"  virtualScrollItemSize="43" 
          [filter]="true"  [virtualScroll]="true" (onChange)="getAllCases('facilityIDs', false)">
        </p-multiSelect>
        </div>
        <div *ngIf="!roleForFacility" class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>QPS:</b></label>
          <span class="p-input-icon-right w-full">
            <p-multiSelect class="w-full" [options]="Teleneuro_QPS" (onChange)="getAllCases('qps', false)"
              [(ngModel)]="selectedTeleneuro_QPS" [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}"
              placeholder="Select QPS" defaultLabel="--Select--" display="chip" optionLabel="Text" optionValue="Value"
              virtualScrollItemSize="43" [filter]="true" [virtualScroll]="true">
            </p-multiSelect>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="caseNumber"><b>Thrombolytic:</b></label>
          <p-dropdown [options]="thrombolyticsOptions" [(ngModel)]="thrombolytics"
            (onChange)="getAllCases('thrombolytics', false)" class="form-control" placeholder="--Select Thrombolytic--"
            optionLabel="name" optionValue="value">
          </p-dropdown>
        </div>
        <div *ngIf="!roleForFacility" class="col-12 md:col-6 lg:col-2">
          <label for="caseNumber"><b>QPS Review Completed:</b></label>
          <p-dropdown [options]="qpsReviewOptions" [(ngModel)]="qpsReviewCompleted"
            (onChange)="getAllCases('qpsReview', false)" class="form-control" optionLabel="name" optionValue="value">
          </p-dropdown>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="caseNumber"><b>Door to Needle Time:</b></label>
          <span class="p-input-icon-right w-full">
            <p-dropdown class="w-full" [options]="doortoNeedleTimeOptions"
              (onChange)="getAllCases('doortoNeedleTime', false)" [(ngModel)]="doortoNeedleTime"
              [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}" placeholder="--Select Needle Time--"
              defaultLabel="--Select--" optionLabel="name" optionValue="value">
            </p-dropdown>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>Time Frame:</b></label>
          <span class="p-input-icon-right w-full" id="frame_up">
            <p-dropdown [options]="timeFameList" (onChange)="onChangeTimeFrame($event)" [(ngModel)]="timeFrame"
              class="form-control" optionLabel="name" optionValue="value">
            </p-dropdown>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>Audio Only:</b></label>
          <span class="p-input-icon-right w-full" id="audio_only">
            <p-dropdown [options]="audioOnlyList" (onChange)="getAllCases('audioOnly', false)" [(ngModel)]="audioOnly"
              class="form-control" placeholder="--Select--" optionValue="value" optionLabel="name">
            </p-dropdown>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>Case Status:</b></label>
          <span class="p-input-icon-right w-full">
            <p-multiSelect class="w-full" (onChange)="getAllCases('status', false)" [options]="statusList"
              placeholder="Select Status" defaultLabel="--Select--" [(ngModel)]="status" optionLabel="name"
              display="chip" optionValue="value">
            </p-multiSelect>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="caseNumber"><b>Case Type:</b></label>
        <span>
          <p-multiSelect [options]="caseTypeOptions" (onChange)="getAllCases('caseType', false)" [(ngModel)]="cas_case_type" optionLabel="Text"
            class="form-control" placeholder="--Select Case Type--" [filter]="true" filterBy="Text" optionValue="Value"
            display="chip"></p-multiSelect>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>Follow-Up:</b></label>
          <span class="p-input-icon-right w-full mt-1" id="follow_up">
            <p-dropdown [options]="folowUpList" (onChange)="getAllCases('followUp', false)" [(ngModel)]="folowUp"
              class="form-control" placeholder="--Select--" optionLabel="name" optionValue="value">
            </p-dropdown>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>Flag:</b></label>
          <span class="p-input-icon-right w-full">
            <p-dropdown [options]="casIsFlaggedList" (onChange)="getAllCases('flag', false)" [(ngModel)]="casIsFlagged"
              class="form-control" placeholder="--Select--" optionValue="value" optionLabel="name">
            </p-dropdown>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <label for="FirstName"><b>Keyword Search:</b></label>
          <span class="p-input-icon-left mt-1 w-full" id="keyword_search">
            <i class="pi pi-search"></i>
            <input pInputText type="text" [(ngModel)]="searchField" (input)="applyFilterGlobal($event, 'contains')"
              placeholder="Search Cases..." id="keyword_search_child" />
              <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool" (click)="clearSearchField()"></i>
          </span>
        </div>
        <div class="col-12 md:col-6 lg:col-3" *ngIf="showDateBool == true">
          <label for="FirstName"><b
              [ngStyle]="specificDatecolorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Date:</b></label>
          <p-calendar [(ngModel)]="txtSpecificDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
          </p-calendar>
        </div>
        <div class="col-12 md:col-6 lg:col-3" *ngIf="showStartEndDateBool == true">
          <label for="FirstName"><b
              [ngStyle]="textStrtColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Start
              Date:</b></label>
          <p-calendar [(ngModel)]="txtStartDate" [minDate]="minDate" [showIcon]="true" inputId="icon" class="mr-2">
          </p-calendar>
        </div>
        <div class="col-12 md:col-6 lg:col-3" *ngIf="showStartEndDateBool == true">
          <label for="FirstName"><b
              [ngStyle]="textEndColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">End
              Date:</b></label>
          <p-calendar [(ngModel)]="txtEndDate" [showIcon]="true" inputId="icon" class="mr-2">
          </p-calendar>

        </div>
        <div class="ml-1 measure-removeflex" id="search_btn">
          <p-button label="Export to Excel" icon="pi pi-upload" (click)="exportExcel()" [loading]="exportExcelLoader"
            class="p-button-primary mr-2 export-largescreen measurecase-btn"></p-button>

          <p-button *ngIf="!roleForFacility" label="Advanced" (click)="advanceSearchModal = true" (onClick)="AdvanceSearch()"
            class="p-button-primary mr-2 measurecase-btn"><i class="pi pi-search-plus mr-2 "></i></p-button>

          <p-button label="Search" icon="pi pi-search" [loading]="loading[0]" (click)="getAllCases('search-btn', false)"
            (onClick)="load(0)" class="p-button-primary mr-2 measurecase-btn"></p-button>
          <p-button *ngIf="clearSearchBool" label="Clear Search" icon="pi pi-times" (click)="ClearSearch()"
            class="p-button-primary mr-2 measurecase-btn"></p-button>

          </div>
      </div>
    </div>
    <div class="bg-default px-3 pb-3">
      <p-table #dt [value]="cases" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines createRoles"
        [paginator]="true" sortMode="multiple" [lazy]="true" (onLazyLoad)="lazyLoadSchedules($event)"
        responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]"
        [globalFilterFields]="['StartTime','Type','PatientName','CaseNumber','CaseStatus']" [resizableColumns]="true"
        columnResizeMode="expand" >
        <ng-template pTemplate="header">
          <tr>
            <th class="width-action">Action </th>
            <th pSortableColumn="CaseNumber" style="width:8rem" pResizableColumn>Case No.
              <p-sortIcon field="CaseNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="AudioOnly"  pResizableColumn>Audio Only
              <p-sortIcon field="AudioOnly"></p-sortIcon>
            </th>
            <th pSortableColumn="PatientID"  pResizableColumn>Patient ID
              <p-sortIcon field="PatientID"></p-sortIcon>
            </th>
            <th pSortableColumn="FacilityName" pResizableColumn>Facility
              <p-sortIcon field="FacilityName"></p-sortIcon>
            </th>
            <th pSortableColumn="PatientDOB" pResizableColumn>Patient DOB
              <p-sortIcon field="PatientDOB"></p-sortIcon>
            </th>
            <th pSortableColumn="LyticCandidate" pResizableColumn>Lytic Candidate
              <p-sortIcon field="LyticCandidate"></p-sortIcon>
            </th>
            <th *ngIf="!roleForFacility" pSortableColumn="CaseStatus">Case Status
              <p-sortIcon field="CaseStatus"></p-sortIcon>
            </th>
            <th *ngIf="!roleForFacility" pSortableColumn="QPSReviewCompleted">QPS Review Completed
              <p-sortIcon field="QPSReviewCompleted"></p-sortIcon>
            </th>
            <th pSortableColumn="FacilityName" pResizableColumn>Identifier
              <p-sortIcon field="FacilityName"></p-sortIcon>
            </th>
            <th pSortableColumn="PhysicianName" pResizableColumn>Physician
              <p-sortIcon field="PhysicianName"></p-sortIcon>
            </th>
            <th pSortableColumn="StartTime" pResizableColumn>Start Time
              <p-sortIcon field="StartTime"></p-sortIcon>
            </th>
            <th pSortableColumn="Type" pResizableColumn>Type
              <p-sortIcon field="Type"></p-sortIcon>
            </th>
            <th pSortableColumn="PatientName" pResizableColumn>Patient Name
              <p-sortIcon field="PatientName"></p-sortIcon>
            </th>
            
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns let-rowIndex="rowIndex">
          <tr>
            <h5 *ngIf="totalRecords==0" class="text-center create-roles">
              <b> No records found</b>
            </h5>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cases>
          <tr>
            <td>
              <span class="no-underline flex">
                <a class="no-underline" (contextmenu)="onContextMenu($event,cases,'Edit')">
                  <button *ngIf="isAccessReadWrite && !roleForFacility && (cases.CaseType == 'Stroke Alert' || cases.CaseType == 'STAT Consult')" pButton pRipple icon="pi pi-pencil" pTooltip="Edit Case Follow Up"
                    tooltipPosition="left" class="p-button-rounded  p-button-primary mr-2"
                    (click)="getElementByFollowUp(cases); onContextMenuPreventDefault($event)"></button>
                </a>
                <a class="no-underline" (contextmenu)="onContextMenu($event,cases,'View')">
                  <button *ngIf="(isAccessReadWrite || isAccessRead) && (cases.CaseType == 'Stroke Alert' || cases.CaseType == 'STAT Consult')" pButton pRipple icon="pi pi-eye"
                    pTooltip="View Case Follow Up" tooltipPosition="bottom"
                    class="p-button-rounded  p-button-primary mr-2"
                    (click)="Viewcasereview(cases); onContextMenuPreventDefault($event)"></button>
                </a>
                <button *ngIf="(isAccessReadWrite || isAccessRead) && !roleForFacility" pButton pRipple icon="pi pi-arrow-up-right"
                  pTooltip="View Case" tooltipPosition="right" class="p-button-rounded  p-button-primary mr-2"
                  (click)="Accesscase(cases)"></button>
              </span>
            </td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CASENumber}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)"><img *ngIf="cases.cas_is_audio_consult" src="../../../../../../assets/images/microphone.png" width="20px"></td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CASEIdentificatinNumber}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.FacilityName}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.PatientDOB | date:'MM/dd/yyyy'}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.cas_metric_tpa_consult == true ? 'Yes' : 'No'}}</td>
            <td *ngIf="!roleForFacility" [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.caseStatusLabel}}</td>
            <td *ngIf="!roleForFacility" [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{(cases.caseStatusLabel === 'Stroke Alert' || cases.caseStatusLabel === 'Stroke Alert') && cases.QPSReviewCompleted == 1?'Yes':''}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CASEIdentificationTYPE}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.PhysicianName}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CaseStartTime | date:'MM/dd/yyyy H:mm:ss'}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.CaseType}}</td>
            <td [pTooltip]="toolTipOption(cases.CaseType)" class="pointer" tooltipPosition="left" (dblclick)="getCaseDetailByDoubleClick(cases)">{{cases.PatientName}}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="md:col-12">
        <span class="tableRefreshTime">
          Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
        </span>
      </div>
    </div>
  </div>
</ng-container>

<!-- Follow Up Edit Screen -->
<ng-container *ngIf="EditScreenBool">

  <div class="content-hide  content-height bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg titlebg-fixed title-case">
      <div class="backbtn-measure -ml-3 cursor-pointer" (click)="backTocasesList('backTocasesList');" pTooltip="Back"
        tooltipPosition="right">
        <i class="pi pi-arrow-left"></i>
      </div>
      <div class="conten measure-content">
        <div class="btn"><a>{{caseHeaderName}}</a></div>
      </div>
      <div class="-ml-5">
        <span class="open-telecase">
          <button *ngIf="!roleForFacility" pButton pRipple type="button" (click)="Accesscase('')" label="OPEN CASE IN TELECARE"
            class="p-button-raised p-button-text p-button-plain"></button>
        </span>
      </div>
    </div>
    <div  class="col-12">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-6">
          <div class="cards">
            <article class="information [ case-card ]">
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Facility:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].FacilityName}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Patient DOB:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].PatientDOB | date:'MM/dd/yyyy'}}</span></dt>
                </div>
              </dl>
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Patient Name:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].PatientName}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Start Time:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CaseStartTime | date:'MM/dd/yyyy H:mm:ss'}}</span></dt>
                </div>
              </dl>
            </article>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="cards">
            <article class="information [ case-card ]">
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Physician:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].PhysicianName}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Case No:</span><span
                      class="dt-text">{{SelectedCaseEdit[0].CASENumber}}</span></dt>
                </div>
              </dl>
              <dl class="details">
                <div>
                  <dt><span class="name-dt">Case Type:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CaseType}}</span></dt>
                </div>
                <div>
                  <dt><span class="name-dt">Patient Identifier:</span> <span
                      class="dt-text">{{SelectedCaseEdit[0].CASEIdentificationTYPE}}</span></dt>
                </div>
              </dl>
            </article>
          </div>
        </div>
      </div>
      <form [formGroup]="form">
        <div class="grid">
          <div [ngClass]="{'disabled':isReadonly}" class="col-12 md:col-12 lg:col-4">
            <h2 class="mt-0 measure-tag">90 Days Modified Rankin Scale:</h2>
            <div class=" grid Modified-ranking DivShape">
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_0_UP" formControlName="cas_premorbid_symptoms"
                  value="0"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">No symptoms at all - 0</label>
              </div>
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_1_UP" formControlName="cas_premorbid_symptoms"
                  value="1"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">No significant disability despite symptoms; able to carry out all usual duties and
                  activities - 1</label>
              </div>
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_2_UP" formControlName="cas_premorbid_symptoms"
                  value="2"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">Slight disability; unable to carry out all previous activities, but able to look
                  after own affairs without assistance - 2</label>
              </div>
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_3_UP" formControlName="cas_premorbid_symptoms"
                  value="3"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">Moderate disability; requiring some help, but able to walk without assistance -
                  3</label>
              </div>
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_4_UP" formControlName="cas_premorbid_symptoms"
                  value="4"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">Moderately severe disability; unable to walk and attend to bodily needs without
                  assistance - 4</label>
              </div>
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_5_UP" formControlName="cas_premorbid_symptoms"
                  value="5"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">Severe disability; bedridden, incontinent and requiring constant nursing care and
                  attention - 5</label>
              </div>
              <div class="md:col-1">
                <p-radioButton id="cas_metric_has_morbid_symptoms_6_UP" formControlName="cas_premorbid_symptoms"
                  value="6"> </p-radioButton>
              </div>
              <div class="md:col-11">
                <label for="radio2">Dead - 6</label>
              </div>
            </div>
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-6">
                <h3 for="Reviewed_By" class="mb-2 font-normal"><b>Reviewed By:</b></h3>
                <span class="mt-2">
                  <p-dropdown [options]="qPSListValues" optionValue="Value" optionLabel="Text" class="mt-2"
                    placeholder="-- Select Reviewed By --" formControlName="cas_premorbid_completed_by">
                  </p-dropdown>
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <h3 class="mb-2 font-normal"><b>Reviewed On:</b></h3>
                <div class="flex align-items-center">
                  <span class="p-input-icon-right">
                    <i (click)="setDateAndTimeDynamically('reviewedOn');" class="pi pi-clock"
                      style="cursor: pointer;"></i>
                    <input formControlName="cas_premorbid_completed_date" [readonly]="true" id="LastName" name="LastName" type="text"
                      class="inputfield" pInputText>
                  </span>
                  <span *ngIf="ReviewOnEst" class="ml-2">{{timeZone}}</span>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-8">
                <label for="Pre-morbidMRS" class="mb-2 font-normal"><b>Pre-Morbid Modified Rankin Scale: </b></label>
                <span
                  *ngIf="cas_metric_has_morbid_symptoms != null"><b>{{cas_metric_has_morbid_symptoms== 7 ? "Unable to assess" : cas_metric_has_morbid_symptoms}}</b></span>
              </div>

            </div>
          </div>

          <div class="col-12 md:col-12 lg:col-8">
            <div class="flex justify-content-between pl-2 pr-2">
            <div [ngClass]="{'disabled':isReadonly}" class="">
              <h3 for="FirstName" class="mb-2 font-normal mt-0"><b>Patient Phone:</b></h3>
              <p-inputMask class="w-full" name="primaryPhone" mask="(999) 999-9999" class="inputfield w-full"
                formControlName="pmc_cas_premorbid_patient_phone">
              </p-inputMask>
            </div>
            <div class="">
              <p-checkbox [disabled]="roleForFacility" [ngStyle]="roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}"  
              [readonly]="true" formControlName="pmc_cas_final_attempt" [binary]="true" inputId="binary" (click)="ClickFinalAttempt()" class="margin-checkbox"></p-checkbox>
              <label class="font-normal font-bold ml-2" style="font-family: Arial"><b>Final Attempt</b></label>
            </div>
          </div>
            <div class="col-12 md:col-12 lg:col-12">

              <table class="table table-bordered" styleClass="p-datatable-gridlines">
                <tr class="table-header">
                  <th class="table-header-th" style="width: 150px;">Date And Time Of Contact</th>
                  <th class="table-header-th" style="width: 50px;">Spoke With</th>
                  <th class="table-header-th" style="width: 120px;">Comments</th>
                  <th class="table-header-th" style="width: 150px;">Action</th>
                  <th class="table-header-th" style="width: 70px;">Completed By</th>
                </tr>
                <!-- First Row -->
                <tr>
                  <td [ngClass]="{'disabled':isReadonly}"><span class="p-input-icon-right">
                      <i (click)="setDateAndTimeDynamically('dateAndTimeOfContact_1');" class="pi pi-clock"
                        style="cursor: pointer;"></i>
                      <input id="pmc_cas_premorbid_datetime_of_contact_1" [readonly]="true" 
                        formControlName="pmc_cas_premorbid_datetime_of_contact_1" type="text" class="inputfield"
                        pInputText>
                    </span></td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <span class="p-input-icon-right w-full">
                      <p-dropdown [options]="spokeWithList" id="pmc_cas_premorbid_spokewith_1"
                        formControlName="pmc_cas_premorbid_spokewith_1" class="form-control" optionLabel="name"
                        optionValue="value" [showClear]="true">
                      </p-dropdown>
                    </span>
                  </td>
                  <td>
                    <span class="p-input-icon-right w-full">
                      <textarea class="cases-textarea" id="pmc_cas_premorbid_comments_1"
                        formControlName="pmc_cas_premorbid_comments_1" rows="2" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                    </span>
                  </td>
                  <td [ngClass]="{'disabled':isReadonly}" class="d-flex align-items-center">
                    <div class="mb-1">
                    <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('first Completed')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_first1" [value]=1
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_first">
                    </p-radioButton>
                    <label class="ml-1 " for="IsEEG">Completed</label>
                  </div>
                    <div class="mb-1">
                    <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('first Unsuccessfull')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_first2" [value]=2
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_first">
                    </p-radioButton>
                    <label class="ml-1" for="IsEEG">Unsuccessful</label>
                  </div>
                    <div class="mb-1">
                    <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('first close')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_first3" [value]=3
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_first">
                    </p-radioButton>
                    <label class="ml-1 " for="IsEEG">Unsuccessful/Close
                    </label>
                  </div>
                  </td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <input type="text" pInputText id="pmc_cas_premorbid_completedby_1"
                      formControlName="pmc_cas_premorbid_completedby_1" />
                  </td>
                </tr>
                <!-- Second Row -->
                <tr *ngIf="!firstUnsuccessfull">
                  <td [ngClass]="{'disabled':isReadonly}"><span class="p-input-icon-right">
                      <i (click)="setDateAndTimeDynamically('dateAndTimeOfContact_2');" class="pi pi-clock"
                        style="cursor: pointer;"></i>
                      <input id="pmc_cas_premorbid_datetime_of_contact_2" [readonly]="true" 
                        formControlName="pmc_cas_premorbid_datetime_of_contact_2" type="text" class="inputfield"
                        pInputText>
                    </span></td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <span class="p-input-icon-right w-full">
                      <p-dropdown [options]="spokeWithList" id="pmc_cas_premorbid_spokewith_2"
                        formControlName="pmc_cas_premorbid_spokewith_2" class="form-control" optionLabel="name"
                        optionValue="value" [showClear]="true">
                      </p-dropdown>
                    </span>
                  </td>
                  <td>
                    <span class="p-input-icon-right w-full">
                      <textarea class="cases-textarea" id="pmc_cas_premorbid_comments_2"
                        formControlName="pmc_cas_premorbid_comments_2" rows="3" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                    </span>
                  </td>
                  <td [ngClass]="{'disabled':isReadonly}" class="d-flex align-items-center">
                    <div class="mb-1">
                    <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('Second Completed')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_second1" [value]=1
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_second">
                    </p-radioButton>
                    <label class="ml-1 " for="IsEEG">Completed</label>
                  </div>
                    <div class="mb-1">
                    <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('Second Unsuccessfull')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_second2" [value]=2
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_second">
                    </p-radioButton>
                    <label class="ml-1" for="IsEEG">Unsuccessful</label>
                  </div>
                    <div class="mb-1">
                    <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('Second Close')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_second3" [value]=3
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_second">
                    </p-radioButton>
                    <label class="ml-1 " for="IsEEG">Unsuccessful/Close
                    </label>
                  </div>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <input type="text" pInputText id="pmc_cas_premorbid_completedby_2"
                      formControlName="pmc_cas_premorbid_completedby_2" />
                  </td>
                </tr>
                <!-- Third Row -->
                <tr *ngIf="!secondUnsuccessfull">
                  <td [ngClass]="{'disabled':isReadonly}"><span class="p-input-icon-right">
                      <i (click)="setDateAndTimeDynamically('dateAndTimeOfContact_3');" class="pi pi-clock"
                        style="cursor: pointer;"></i>
                      <input id="pmc_cas_premorbid_datetime_of_contact_3" [readonly]="true" 
                        formControlName="pmc_cas_premorbid_datetime_of_contact_3" type="text" class="inputfield"
                        pInputText>
                    </span></td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <span class="p-input-icon-right w-full">
                      <p-dropdown [options]="spokeWithList" class="ml-3 mb-1" id="pmc_cas_premorbid_spokewith_3"
                        formControlName="pmc_cas_premorbid_spokewith_3" class="form-control" optionLabel="name"
                        optionValue="value" [showClear]="true">
                      </p-dropdown>
                    </span>
                  </td>
                  <td>
                    <span class="p-input-icon-right w-full">
                      <textarea class="cases-textarea" id="pmc_cas_premorbid_comments_3"
                        formControlName="pmc_cas_premorbid_comments_3" rows="3" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                    </span>
                  </td>
                  <td [ngClass]="{'disabled':isReadonly}" class="d-flex align-items-center">
                    <div class="mb-1">
                      <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('Third Completed')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_first1" [value]=1
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_third">
                      </p-radioButton>
                      <label class="ml-1 " for="IsEEG">Completed</label>
                    </div>
                    <div class="mb-1">
                      <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('Third Unsuccessfull')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_first2" [value]=2
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_third">
                      </p-radioButton>
                      <label class="ml-1" for="IsEEG">Unsuccessful</label>
                    </div>
                    <div class="mb-1">
                      <p-radioButton class="ml-3" (click)="addCorrespondenceRecord('Third Close')"
                      id="pmc_cas_premorbid_successful_or_unsuccessful_first3" [value]=3
                      formControlName="pmc_cas_premorbid_successful_or_unsuccessful_third">
                      </p-radioButton>
                      <label class="ml-1 " for="IsEEG">Unsuccessful/Close
                      </label>
                    </div>
                  </td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <input type="text" pInputText id="pmc_cas_premorbid_completedby_3"
                      formControlName="pmc_cas_premorbid_completedby_3" />
                  </td>
                </tr>
                <!-- Fourth Row -->
                <tr *ngIf="thirdUnsuccessfull" [ngStyle]="roleForFacility?{'pointer-events': 'none'} : {'pointer-events': 'all'}" >
                  <td [ngClass]="{'disabled':isReadonly}"><span class="p-input-icon-right">
                      <i (click)="setDateAndTimeDynamically('dateAndTimeOfContact_4');" class="pi pi-clock"
                        style="cursor: pointer;"></i>
                      <input id="pmc_cas_premorbid_datetime_of_contact_4" [readonly]="true" 
                        formControlName="pmc_cas_premorbid_datetime_of_contact_4" type="text" class="inputfield"
                        pInputText>
                    </span></td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <span class="p-input-icon-right w-full">
                      <p-dropdown [options]="spokeWithList" class="ml-3 mb-1" id="pmc_cas_premorbid_spokewith_4"
                        formControlName="pmc_cas_premorbid_spokewith_4" class="form-control" optionLabel="name"
                        optionValue="value" [showClear]="true">
                      </p-dropdown>
                    </span>
                  </td>
                  <td>
                    <span class="p-input-icon-right w-full">
                      <textarea class="cases-textarea" id="pmc_cas_premorbid_comments_4"
                        formControlName="pmc_cas_premorbid_comments_4" rows="3" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                    </span>
                  </td>
                  <td [ngClass]="{'disabled': isReadonly}">
                    <div class="mb-1">
                        <p-radioButton (click)="addCorrespondenceRecord('Fourth Completed')" class="ml-3"
                            id="pmc_cas_premorbid_successful_or_unsuccessful_first1" [value]=1
                            formControlName="pmc_cas_premorbid_successful_or_unsuccessful_fourth">
                        </p-radioButton>
                        <label class="ml-1" for="IsEEG">Completed</label>
                    </div>
                    <div class="mb-1">
                        <p-radioButton (click)="addCorrespondenceRecord('Fourth Unsuccessful')" class="ml-3"
                            id="pmc_cas_premorbid_successful_or_unsuccessful_first2" [value]=2
                            formControlName="pmc_cas_premorbid_successful_or_unsuccessful_fourth">
                        </p-radioButton>
                        <label class="ml-1" style="font-size: 12px; white-space: nowrap;" for="IsEEG">Unsuccessful/<b>Final Attempt</b></label>
                    </div>
                </td>
                  <td [ngClass]="{'disabled':isReadonly}">
                    <input type="text" pInputText id="pmc_cas_premorbid_completedby_4"
                      formControlName="pmc_cas_premorbid_completedby_4" />
                  </td>
                </tr>
              </table>
            </div>

            <!-- Patient Satisfaction Block -->
            <div [ngClass]="{'disabled':isReadonly}" class="grid DivShape pt-1 pb-1">
              <div class="col-12 md:col-12 lg:col-12 text-center">
                <label class="-mb-3 ml-3 mr-3 font-bold text-primary-qms" for="1"><b>1: Very Unsatisfied</b></label>
                <label class="-mb-3 ml-3 mr-3 font-bold text-primary-qms" for="2"><b>2: Unsatisfied</b></label>
                <label class="-mb-3 ml-3 mr-3 font-bold text-primary-qms" for="3"><b>3: Neutral</b></label>
                <label class="-mb-3 ml-3 mr-3 font-bold text-primary-qms" for="4"><b>4: Satisfied</b></label>
                <label class="-mb-3 ml-3 mr-3 font-bold text-primary-qms" for="5"><b>5: Very Satisfied</b></label>
              </div>
              <div class="col-12 md:col-12 lg:col-12">
                <h3 for="FirstName" class="mb-2 mt-1 font-medium"><b>Patient Satisfaction 1 - Video Experience:</b>
                </h3>
                <span class="p-input-icon-right w-full measure-satisfiction">
                  <p-radioButton id="cas_response_case_facility_request_reviewed1" class="ml-3 " [value]=1
                    formControlName="pmc_cas_patient_satisfaction_video_experience">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">1</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed2" class="ml-3 " [value]=2
                    formControlName="pmc_cas_patient_satisfaction_video_experience">
                  </p-radioButton>
                  <label class="m-2" for="radio2">2</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed3" class="ml-3 " [value]="3"
                    formControlName="pmc_cas_patient_satisfaction_video_experience">
                  </p-radioButton>
                  <label class="m-2" for="radio2">3</label>
                  <br>
                  <p-radioButton id="cas_response_case_facility_request_reviewed4" class="ml-3 " [value]=4
                    formControlName="pmc_cas_patient_satisfaction_video_experience">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">4</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed5" class="ml-3 " [value]="5"
                    formControlName="pmc_cas_patient_satisfaction_video_experience">
                  </p-radioButton>
                  <label class="m-2" for="radio2">5</label>
                  <br>
                  <p-radioButton id="cas_response_case_facility_request_reviewed6" class="ml-3" [value]="6"
                    formControlName="pmc_cas_patient_satisfaction_video_experience">
                  </p-radioButton>
                  <label class="m-2" for="radio2">N/A or Patient Doesn’t Remember</label>
                </span>
              </div>

              <!-- Patient satification 2 communication -->
              <div class="col-12 md:col-12 lg:col-12">
                <h3 for="FirstName" class="mb-2 mt-1 font-medium"><b>Patient Satisfaction 2- Communication:</b></h3>
                <span class="p-input-icon-right w-full measure-satisfiction">
                  <p-radioButton id="cas_response_case_facility_request_reviewed1" class="ml-3" [value]=1
                    formControlName="pmc_cas_patient_satisfaction_communication">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">1</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed2" class="ml-3" [value]=2
                    formControlName="pmc_cas_patient_satisfaction_communication">
                  </p-radioButton>
                  <label class="m-2" for="radio2">2</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed3" class="ml-3" [value]="3"
                    formControlName="pmc_cas_patient_satisfaction_communication">
                  </p-radioButton>
                  <label class="m-2" for="radio2">3</label>
                  <br>
                  <p-radioButton id="cas_response_case_facility_request_reviewed4" class="ml-3" class="ml-3" [value]=4
                    formControlName="pmc_cas_patient_satisfaction_communication">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">4</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed5" class="ml-3" [value]="5"
                    formControlName="pmc_cas_patient_satisfaction_communication">
                  </p-radioButton>
                  <label class="m-2" for="radio2">5</label>
                  <br>
                  <p-radioButton id="cas_response_case_facility_request_reviewed6" class="ml-3" [value]="6"
                    formControlName="pmc_cas_patient_satisfaction_communication">
                  </p-radioButton>
                  <label class="m-2" for="radio2">N/A or Patient Doesn’t Remember</label>
                </span>
              </div>

              <!-- Patient satification_3 Overall -->
              <div class="col-12 md:col-12 lg:col-12">
                <h3 for="FirstName" class="mb-2 mt-1 font-medium"><b>Patient Satisfaction 3- Overall:</b></h3>
                <span class="p-input-icon-right w-full measure-satisfiction">
                  <p-radioButton id="cas_response_case_facility_request_reviewed1" class="ml-3" [value]=1
                    formControlName="pmc_cas_patient_satisfaction_overall">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">1</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed2" class="ml-3" [value]=2
                    formControlName="pmc_cas_patient_satisfaction_overall">
                  </p-radioButton>
                  <label class="m-2" for="radio2">2</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed3" class="ml-3" [value]="3"
                    formControlName="pmc_cas_patient_satisfaction_overall">
                  </p-radioButton>
                  <label class="m-2" for="radio2">3</label>
                  <br>
                  <p-radioButton id="cas_response_case_facility_request_reviewed4" class="ml-3" [value]=4
                    formControlName="pmc_cas_patient_satisfaction_overall">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">4</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed5" class="ml-3" [value]="5"
                    formControlName="pmc_cas_patient_satisfaction_overall">
                  </p-radioButton>
                  <label class="m-2" for="radio2">5</label>
                  <br>
                  <p-radioButton id="cas_response_case_facility_request_reviewed6" class="ml-3" [value]="6"
                    formControlName="pmc_cas_patient_satisfaction_overall">
                  </p-radioButton>
                  <label class="m-2" for="radio2">N/A or Patient Doesn’t Remember</label>
                </span>
              </div>

              <!-- Willing to do Interview: -->
              <div class="col-12 md:col-12 lg:col-12">
                <h3 for="FirstName" class="mb-2 mt-1 font-medium"><b>Willing to do Interview:</b></h3>
                <span class="p-input-icon-right w-full measure-satisfiction">
                  <p-radioButton id="cas_response_case_facility_request_reviewed1"
                    (click)="showConsentSentReceived('yes')" class="ml-3" [value]="1"
                    formControlName="pmc_cas_willing_todo_interview">
                  </p-radioButton>
                  <label class="m-2" for="IsEEG">Yes</label>
                  <p-radioButton id="cas_response_case_facility_request_reviewed2"
                    (click)="showConsentSentReceived('No')" [value]="2"
                    formControlName="pmc_cas_willing_todo_interview">
                  </p-radioButton>
                  <label class="m-2" for="radio2">No</label>

                </span>
              </div>

              <div class="grid" *ngIf="pmc_cas_willing_todo_interview_bool">
                <!-- Consent Sent: -->
                <div class="field md:col-12">
                  <h3 for="FirstName" class="mb-2 mt-1 font-medium"><b>Consent Sent:</b></h3>
                  <span class="p-input-icon-right w-full flex">
                    <p-radioButton id="pmc_cas_consent_sent1" class="ml-3" [value]="1"
                      formControlName="pmc_cas_consent_sent">
                    </p-radioButton>
                    <label class="-mb-3 ml-3 mr-3" for="IsEEG">Yes</label>
                    <p-radioButton id="pmc_cas_consent_sent2" [value]="2" formControlName="pmc_cas_consent_sent">
                    </p-radioButton>
                    <label class="-mb-3 ml-3 mr-3" for="radio2">No</label>
                  </span>
                </div>

                <!-- Consent Received: -->
                <div class="field md:col-12">
                  <h3 for="FirstName" class="mb-2 mt-1 font-medium"><b>Consent Received:</b></h3>
                  <span class="p-input-icon-right w-full flex">
                    <p-radioButton id="pmc_cas_consent_received1" class="ml-3" [value]="1"
                      formControlName="pmc_cas_consent_received">
                    </p-radioButton>
                    <label class="-mb-3 ml-3 mr-3" for="IsEEG">Yes</label>
                    <p-radioButton id="pmc_cas_consent_received2" [value]="2"
                      formControlName="pmc_cas_consent_received">
                    </p-radioButton>
                    <label class="-mb-3 ml-3 mr-3" for="radio2">No</label>

                  </span>
                </div>
              </div>
            </div>
            <!-- Patient Satisfaction Block End -->
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-6">
                <h3 class="mb-2 font-normal"><b>Patient Satisfaction Notes:</b></h3>
                <span class="p-input-icon-right w-full">
                  <textarea formControlName="cas_premorbid_symptoms_text" placeholder="Enter Text..." rows="3" cols="30"
                  [readonly]="isReadonly"  pInputTextarea></textarea>
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <h3 class="mb-2 font-normal"><b>Facility Satisfaction Notes:</b></h3>
                <span class="p-input-icon-right w-full">
                  <textarea class="cases-textarea" formControlName="cas_premorbid_fac_satisfaction_notes"
                    placeholder="Enter Text..." rows="3" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                </span>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <h3 class="mb-2 mt-1 font-normal"><b>Facility Contact name:</b></h3>
                <span class="p-input-icon-right w-full">
                  <textarea class="cases-textarea" formControlName="cas_premorbid_fac_contact_name"
                    placeholder="Enter Text..." rows="3" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                </span>
              </div>

              <div [ngClass]="{'disabled':isReadonly}" class="col-12 md:col-12 lg:col-6">
                <h3 class="mb-2 mt-1 font-normal"><b>Approved for Quote:</b></h3>
                <span class="p-input-icon-right w-full mt-4">
                  <p-radioButton id="cas_premorbid_approved_for_quote_true" class="ml-3"
                    (click)="showContactPersonName('true')" [value]="true"
                    formControlName="cas_premorbid_approved_for_quote">
                  </p-radioButton>
                  <label class="-mb-3 ml-3 mr-3" for="IsEEG">Yes</label>
                  <p-radioButton id="cas_premorbid_approved_for_quote_false" (click)="showContactPersonName('false')"
                    [value]="false" formControlName="cas_premorbid_approved_for_quote">
                  </p-radioButton>
                  <label class="-mb-3 ml-3 mr-3" for="radio2">No</label>
                </span>
              </div>

              <div *ngIf="cas_premorbid_approved_for_quote_bool" class="col-12 md:col-12 lg:col-6">
                <h3 class="mb-2 font-normal mt-1"><b>Contact Person Name:</b></h3>
                <div *ngIf="cas_premorbid_approved_for_quote_bool">
                  <span class="p-input-icon-right w-full">
                    <textarea class="cases-textarea" formControlName="cas_premorbid_contact_person_name"
                      placeholder="Enter Text..." rows="3" cols="30" [readonly]="isReadonly" pInputTextarea></textarea>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!isReadonly" class="col-12 md:col-12 text-right mt-3">
          <div class="formgrid flex m-2 justify-content-end">
            <button (click)="backTocasesList('backToCASESList');" type="button" class="btn-Cancel">Cancel</button>
            <p-button *ngIf="!showSaveBool" (click)="saveFollowUpData('save');"
              class="ml-2 p-button-primary btn-padding-custom" type="button" label="Save"></p-button>
            <p-button *ngIf="!showSaveBool" (click)="saveFollowUpData('saveAndClose');"
              class="ml-2 p-button-primary btn-padding-custom" type="button" label="Save & Close"></p-button>
            <button *ngIf="showSaveBool" (click)="unCancelCase()" type="button" class="ml-2 btn-UnCancelCasee">Un-Cancel
              Case</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<div class="toast-container" [ngClass]="{'toast-mask': showToast}"></div>
<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="onReject()">
  <p-toast key="DeleteContact" position="top-right"></p-toast>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="onConfirm()" type="button">
          </p-button>
        </div>
        <div class="col-6">
          <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="onReject()" type="button">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<p-dialog [(visible)]="advanceSearchModal" [draggable]="false" [modal]="true" [style]="{width: '35vw'}"
  [breakpoints]="{'960px': '75vw'}">
  <ng-template pTemplate="header">
    <span class="flex align-items-center">
      <img class="advancedimg" src="../../../../../../assets/images/advance-search-icon.png">
      <strong class="text-2xl ml-1">Advanced Search</strong>
    </span>
  </ng-template>
  <form [formGroup]="advanceFormSearch">
    <div class="grid p-fluid mt-3">
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Case Number:</b></label>
        <input type="text" formControlName="cas_case_number" pInputText>
      </div>
      <!-- <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Case Types:</b></label>
        <p-multiSelect [options]="caseTypeOptions" formControlName="cas_case_type" optionLabel="Text"
          class="form-control" placeholder="--Select Case Type--" [filter]="true" filterBy="Text" optionValue="Value"
          display="chip"></p-multiSelect>
      </div> -->
      <div class="col-12 md:col-12 lg:col-12">
        <label for="patientName"><b>Patient Name:</b></label>
        <input name="cas_patient" type="text" pInputText formControlName="cas_patient">
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="date"><b>Date:</b></label>
        <p-calendar [showIcon]="true" formControlName="cas_advance_date" inputId="icon"></p-calendar>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Follow Up:</b></label>
        <span class="p-input-icon-right w-full mt-1" id="follow_up">
          <p-multiSelect [options]="folowUpList" formControlName="folowUp" filterBy="name" display="chip"
            class="form-control" placeholder="--Select Follow Up--" optionLabel="name" optionValue="value">
          </p-multiSelect>
        </span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="patientName"><b>Patient Identification Number:</b></label>
        <input name="cas_patient" type="text" pInputText formControlName="CASEIdentificatinNumber">
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Physician:</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect [options]="physicionList" formControlName="selectedPhysicion" optionLabel="Name"
            class="form-control" placeholder="--Select Physician--" [filter]="true" filterBy="Name" optionValue="Id"
            display="chip" (onClick)="GetFacilityPhysicion()"></p-multiSelect>
        </span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>eAlert:</b></label>
        <p-dropdown [options]="eAlertOptions" formControlName="cas_eAlert" class="form-control"
          placeholder="--Select eAlert--" optionLabel="Text" optionValue="Value">
        </p-dropdown>
      </div>

      <div class="col-12 md:col-12 lg:col-12">
        <label for="caseNumber"><b>Workflow Type:</b></label>
        <p-multiSelect [options]="selectWorkFlowTypeOptions" formControlName="work_flow_type" class="form-control"
          placeholder="--Select Workflow Type--" optionValue="Value" optionLabel="Text" filterBy="Text" display="chip">
        </p-multiSelect>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="advanceSearchModal=false" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
    <p-button type="button" icon="pi pi-search" label="Search" (click)="getAllCases('advance', true)"
      [loading]="advanceSearchLoader" styleClass="p-button-text"></p-button>
  </ng-template>

</p-dialog>
